module.exports = __webpack_public_path__ + "static/media/Excel.a2bf0a27.svg";